import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const ShiftPolicy = () => {
  const userData = useSelector(loggedInUser);

  const {
    data: shiftPolicies,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetAllShiftPoliciesQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isTrue: true,
  });

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = shiftPolicies?.map((d, _id) => ({
    id: _id + 1,
    ...d,
    shiftStartTime: moment(d.shiftStartTime, ["HH:mm"]).format("hh:mm A"),
    shiftEndTime: moment(d.shiftEndTime, ["HH:mm"]).format("hh:mm A"),
    shift1stHalfDayEndTime: moment(d.shift1stHalfDayEndTime, ["HH:mm"]).format(
      "hh:mm A"
    ),
    shift2ndHalfDayStartTime: moment(d.shift2ndHalfDayStartTime, [
      "HH:mm",
    ]).format("hh:mm A"),
  }));

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "SNo",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },

    {
      title: "Shift Name",
      dataIndex: "shiftName",
      fixed: "left",
      sorter: (a, b) => a.shiftName.length - b.shiftName.length,
    },

    // {
    //   title: "Shift Type",
    //   dataIndex: "shiftType",
    //   sorter: (a, b) => a.shiftType.length - b.shiftType.length,
    // },
    {
      title: "Shift Start Time",
      dataIndex: "shiftStartTime",
      // sorter: (a, b) => a.shiftStartTime.length - b.shiftStartTime.length,
      // render: (text, record) => moment(text, ["HH:mm"]).format("hh:mm A"),
    },
    {
      title: "Shift End Time",
      dataIndex: "shiftEndTime",
      // sorter: (a, b) => a.shiftEndTime.length - b.shiftEndTime.length,
      // render: (text, record) => moment(text, ["HH:mm"]).format("hh:mm A"),
    },
    {
      title: "Total Shift Hours",
      dataIndex: "totalShiftHours",
    },
    {
      title: "Shift 1stHalf Day End Time",
      dataIndex: "shift1stHalfDayEndTime",
      // sorter: (a, b) =>
      //   a.shift1stHalfDayEndTime.length - b.shift1stHalfDayEndTime.length,
      // render: (text, record) => moment(text, ["HH:mm"]).format("hh:mm A"),
    },
    {
      title: "Shift 2ndHalf Day Start Time",
      dataIndex: "shift2ndHalfDayStartTime",
      // sorter: (a, b) =>
      //   a.shift2ndHalfDayStartTime.length - b.shift2ndHalfDayStartTime.length,
      // render: (text, record) => ,
    },
    {
      title: "Total Break Hours",
      dataIndex: "totalBreakHours",
    },
    {
      title: "Total Working Hours",
      dataIndex: "totalWorkingHours",
    },
    // {
    //   title: "Current Day Rate",
    //   dataIndex: "currentDayRate",
    //   sorter: (a, b) => a.currentDayRate.length - b.currentDayRate.length,
    // },
    // {
    //   title: "Next Day OT Rate",
    //   dataIndex: "nextDayOTRate",
    //   sorter: (a, b) => a.nextDayOTRate.length - b.nextDayOTRate.length,
    // },
    // {
    //   title: "Earliest Clock In",
    //   dataIndex: "earliestClockIn",
    //   sorter: (a, b) => a.earliestClockIn.length - b.earliestClockIn.length,
    // },
    // {
    //   title: "Latest Clock In",
    //   dataIndex: "latestClockIn",
    //   sorter: (a, b) => a.latestClockIn.length - b.latestClockIn.length,
    // },
    // {
    //   title: "Shift Allowance",
    //   dataIndex: "shiftAllowance",
    //   sorter: (a, b) => a.shiftAllowance.length - b.shiftAllowance.length,
    // },

    // {
    //   title: "Additional Hour",
    //   dataIndex: "additionalHour",
    //   sorter: (a, b) => a.additionalHour.length - b.additionalHour.length,
    // },

    // {
    //   title: "Shift Grace Time",
    //   dataIndex: "shiftGraceTime",
    //   sorter: (a, b) => a.shiftGraceTime.length - b.shiftGraceTime.length,
    // },

    // {
    //   title: "Meal Allowance",
    //   dataIndex: "mealAllowance",
    //   sorter: (a, b) => a.mealAllowance.length - b.mealAllowance.length,
    // },

    // {
    //   title: "Break Hour OT Rate",
    //   dataIndex: "breakHourOTRate",
    //   sorter: (a, b) => a.breakHourOTRate.length - b.breakHourOTRate.length,
    // },
    // {
    //   title: "Early Clock In OT Rate",
    //   dataIndex: "earlyClockInOTRate",
    //   sorter: (a, b) =>
    //     a.earlyClockInOTRate.length - b.earlyClockInOTRate.length,
    // },

    // {
    //   title: "Shift Type ID",
    //   dataIndex: "shiftTypeID",
    //   sorter: (a, b) => a.shiftTypeID.length - b.shiftTypeID.length,
    // },

    // {
    //   title: "Status",
    //   dataIndex: "isActive",
    //   render: (text) => (
    //     <>
    //       {text === true && (
    //         <div className="badges badge-linesuccess">Active</div>
    //       )}
    //       {text === false && (
    //         <div className="badges badge-linedanger">In Active</div>
    //       )}
    //     </>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.shift_management}
            accessCode={accessCodes.shift_policy}
            accessType="haveEdit"
          >
            <Link
              className="me-2 p-2"
              to={`${all_routes.shift}${all_routes.shift_policy}${all_routes.edit_shift_policy}/${record.shiftPolicyID}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Company Shift Policy</h4>
                <h6>Manage Company Shift Policy</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName={`Shift Policies Master`}
                pdfTheme="plain"
                refresh={GetItems}
              />
            </div>

            <div className="page-btn">
              <Can
                accessModule={accessCodes.shift_management}
                accessCode={accessCodes.shift_policy}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Shift Policy</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.shift}${all_routes.shift_policy}${all_routes.add_shift_policy}`}
                    className="btn btn-added"
                  >
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
          </div>

          {/* /product list */}
          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div
                className="table-responsive"
                style={{ padding: "0px 0px 20px" }}
              >
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                  pagination={false}
                  scroll={{ x: "max-content", y: 600 }}
                  sticky={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShiftPolicy;
